import React, { useMemo } from "react";
import Dropzone from "react-dropzone";
import { Alert, Spinner, Form, Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCircleNotch,
  faBan,
} from "@fortawesome/free-solid-svg-icons";
import TabSection from "../../../../../configurationTab/tabSection/TabSection";

class FileAssignmentDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isInFlight: false,
      isOpen: true,
      remountTab: Date.now(),
    };

    this.baseStyle = {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      borderWidth: 2,
      borderRadius: 2,
      borderColor: "#eeeeee",
      borderStyle: "dashed",
      backgroundColor: "#fafafa",
      color: "#bdbdbd",
      outline: "none",
      transition: "border .24s ease-in-out",
    };

    this.activeStyle = {
      borderColor: "#2196f3",
    };

    this.acceptStyle = {
      borderColor: "#00e676",
    };

    this.rejectStyle = {
      borderColor: "#ff1744",
    };

    this.handleUpload = this.handleUpload.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.humanReadableFileSize = this.humanReadableFileSize.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleHide() {
    this.props.onHide();
  }

  async handleUpload(files) {
    this.setState({ isInFlight: true, isOpen: false });

    try {
      await this.props.onUpload(files);
    } finally {
      this.setState({ isInFlight: false, remountTab: Date.now() });
    }
  }

  humanReadableFileSize(size) {
    const labels = ["B", "KB", "MB", "GB"];
    let ct = 0;
    while (size > 1024 && ct < labels.length) {
      size /= 1024;
      ct++;
    }
    return `${Math.round(size * 100) / 100} ${labels[ct]}`;
  }

  handleToggle = (e) => {
    this.props.onChangeSearchObj(e.target.id);
  };

  render() {
    const { t } = this.props;
    const fileState = [
      <FontAwesomeIcon
        key={1}
        icon={faCircleNotch}
        pulse
        className="color-black mr-2"
      />,
      <FontAwesomeIcon key={2} icon={faCheck} className="color-green mr-2" />,
      <FontAwesomeIcon key={3} icon={faBan} className="color-red mr-2" />,
    ];
    const notNullExams = [];
    const nullExams = [];
    this.props.studentExaminationFiles.forEach((i) => {
      i.instance ? notNullExams.push(i) : nullExams.push(i);
    });
    const sortedExams = [...nullExams, ...notNullExams];

    return (
      <div className="mt-2">
        {this.props.dialogApiError}
        {this.props.instanceTemplate.type === 2
        || (this.props.instanceTemplate.type === 1
            && (this.props.examination.securityLevel === 5 || this.props.examination.securityLevel === 6)) ? (
            <Alert key="2" variant="warning">
              <b>
                {t(
                    "SingleExamination.InstanceTab.FileAssignmentDialog.AllowedFileTypes"
                )}
              </b>
            </Alert>
        ) : ""}
        <div className="mb-3">
          {t("SingleExamination.InstanceTab.FileAssignmentDialog.Description")}
        </div>
        <TabSection
          key={this.state.remountTab}
          openbydefault={this.state.isOpen}
          title={t(
            "SingleExamination.InstanceTab.FileAssignmentDialog.TabSectionTitle"
          )}
          description={t(
            "SingleExamination.InstanceTab.FileAssignmentDialog.TabSectionDescription"
          )}
        >
          <Form.Group>
            <div className="mb-4">
              {t(
                "SingleExamination.InstanceTab.FileAssignmentDialog.TabSectionDescription"
              )}
            </div>
            <div className="custom-checkbox">
              <Form.Check
                custom
                id="searchInFileContent"
                type="checkbox"
                label={t(
                  "SingleExamination.InstanceTab.FileAssignmentDialog.SearchInFile"
                )}
                checked={this.props.searchObject.searchInFileContent}
                onChange={this.handleToggle}
              />
            </div>
          </Form.Group>
          <Form.Group>
            <div className="custom-checkbox">
              <Form.Check
                custom
                id="id"
                type="checkbox"
                label={t(
                  "SingleExamination.InstanceTab.FileAssignmentDialog.SearchId"
                )}
                checked={this.props.searchObject.searchAttributes.includes(
                  "id"
                )}
                onChange={this.handleToggle}
              />
            </div>
            <div className="custom-checkbox">
              <Form.Check
                custom
                id="email"
                type="checkbox"
                label={t(
                  "SingleExamination.InstanceTab.FileAssignmentDialog.SearchEmail"
                )}
                checked={this.props.searchObject.searchAttributes.includes(
                  "email"
                )}
                onChange={this.handleToggle}
              />
            </div>
            <div className="custom-checkbox">
              <Form.Check
                custom
                type="checkbox"
                id="name"
                label={t(
                  "SingleExamination.InstanceTab.FileAssignmentDialog.SearchName"
                )}
                checked={this.props.searchObject.searchAttributes.includes(
                  "name"
                )}
                onChange={this.handleToggle}
              />
            </div>
            <Form.Control
              type="hidden"
              isInvalid={
                this.props?.searchObject?.searchAttributes.length === 0
              }
            />
            <Form.Control.Feedback type="invalid">
              {t(
                "SingleExamination.InstanceTab.FileAssignmentDialog.NoCheckBoxNotification"
              )}
            </Form.Control.Feedback>
          </Form.Group>
        </TabSection>
        {!(this.props?.searchObject?.searchAttributes.length === 0) && (
          <Dropzone onDrop={this.handleUpload}>
            {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragAccept,
              isDragReject,
            }) => {
              const style = useMemo(
                () => ({
                  ...this.baseStyle,
                  ...(isDragActive ? this.activeStyle : {}),
                  ...(isDragAccept ? this.acceptStyle : {}),
                  ...(isDragReject ? this.rejectStyle : {}),
                }),
                [isDragActive, isDragReject, isDragAccept]
              );

              return (
                <section className="container mt-2 pl-0 pr-0">
                  <div {...getRootProps({ style })}>
                    <input {...getInputProps()} />
                    <p>
                      {" "}
                      {t(
                        "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.DragNDropBody"
                      )}
                    </p>
                  </div>
                  <aside>
                    {this.props.studentExaminationFiles.length === 0 ? (
                      <div className="mt-3">
                        <h5>
                          {t(
                              "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.Files"
                          )}
                        </h5>
                        <div className="mt-2">
                          <b>
                            {t(
                                "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.NoFilesUploaded"
                            )}
                          </b>
                        </div>
                        <div
                          style={
                            this.state.isInFlight ? { textAlign: "center" } : {}
                          }
                        >
                          {this.state.isInFlight ? (
                            <Spinner animation="border" />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        <h5>
                          {t(
                              "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.Files"
                          )}
                        </h5>
                        <div className="mt-2">
                          <ul style={{ listStyle: "none", padding: "0px" }}>
                            <li>
                              <FontAwesomeIcon
                                icon={faCheck}
                                className="color-green mr-2"
                              />
                              {t(
                                "SingleExamination.InstanceTab.FileAssignmentDialog.LegendDescOk"
                              )}
                            </li>
                            <li>
                              <span className="fa-layers fa-fw mr-2">
                                <FontAwesomeIcon
                                  icon={faBan}
                                  className="color-red"
                                />
                              </span>
                              {t(
                                "SingleExamination.InstanceTab.FileAssignmentDialog.LegendDescNotOk"
                              )}
                            </li>
                          </ul>
                        </div>
                        <div
                          className="table-responsive"
                          style={{ maxHeight: 300, overflowY: "auto" }}
                        >
                          <Table size="sm mt-2">
                            <thead>
                              <tr>
                                <th>
                                  {t(
                                    "SingleExamination.InstanceTab.FileAssignmentDialog.TableDocName"
                                  )}
                                </th>
                                <th>
                                  {t(
                                    "SingleExamination.InstanceTab.FileAssignmentDialog.TableAssignedPerson"
                                  )}
                                </th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {sortedExams.length > 0 ? (
                                sortedExams.map((i, idx) => (
                                  <tr key={idx}>
                                    <td style={i.status === 2 ? {backgroundColor: "#F88484"} : {}}>
                                      <b>{i.name}</b>
                                    </td>
                                    <td style={i.status === 2 ? {backgroundColor: "#F88484"} : {}}>
                                      <b>{i.instance
                                        ? i.instance.email
                                        : t(
                                            "SingleExamination.InstanceTab.FileAssignmentDialog.NotAssigned"
                                          )}</b>
                                    </td>
                                    <td style={{"textAlign": "center"}}>
                                      {i.status
                                          ? fileState[i.status]
                                          : fileState[0]}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="3">
                                    {t(
                                      "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileOverviewTab.NoUploadsFound"
                                    )}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                        <div
                          className={this.state.isInFlight ? "mt-3" : ""}
                          style={
                            this.state.isInFlight ? { textAlign: "center" } : {}
                          }
                        >
                          {this.state.isInFlight ? (
                            <Spinner animation="border" />
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    )}
                  </aside>
                </section>
              );
            }}
          </Dropzone>
        )}
      </div>
    );
  }
}

export default withTranslation()(FileAssignmentDialog);
